import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Helper } from '../helpers/helper';
import { EmpleadosServicio } from './empleado.service';

@Injectable()
export class CompaniasService {

  constructor( private _http: HttpClient, private helper: Helper,  private empleadoService: EmpleadosServicio ) { }


  cargarTodasLasEmpresas() {
      return this._http.get( `${this.helper.urlServer}/api/v1/listado-empresas`,
      { headers: this.helper.getHeader(localStorage.getItem('token')) } ).map((res: any) => res);
  }

  cargarTodasLasCiudades() {
    return this._http.get( `${this.helper.urlServer}/api/v1/listado-ciudades`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) } ).map((res: any) => res);
}

  cargarCicloActual() {
    return this._http.get( `${this.helper.urlServer}/api/v1/ciclo-actual`,
    { headers: this.helper.getHeader(localStorage.getItem('token')) } ).map((res: any) => res);
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/services/companias.service.ts